import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';

import { Observable, of, map } from 'rxjs';
import { Store } from '@ngrx/store';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { AppState, NativeBridgeService } from '@fcom/core';
import { casProfileName, casProfileOrNot, loginStatus } from '@fcom/core/selectors';
import { CasCustomerType, LoginStatus } from '@fcom/core-api/login';
import { finShare } from '@fcom/rx';
import { ButtonMode, ButtonSize, ButtonTheme, IconPosition } from '@fcom/ui-components';

import { ElementTypes } from '../../interfaces';
import { MediaQueryService } from '../../services';

const SHOW_BUTTON_STATES = [
  LoginStatus.LOGGED_IN,
  LoginStatus.NOT_LOGGED_IN,
  LoginStatus.ERROR,
  LoginStatus.PENDING,
  LoginStatus.INITIAL,
];

@Component({
  selector: 'fin-login-button',
  templateUrl: 'login-button.component.html',
  styleUrls: ['./login-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoginButtonComponent implements OnInit {
  private store$ = inject<Store<AppState>>(Store);
  private nativeBridgeService = inject(NativeBridgeService);
  private mediaQueryService = inject(MediaQueryService);

  readonly ButtonMode = ButtonMode;
  readonly ButtonSize = ButtonSize;
  readonly ButtonTheme = ButtonTheme;
  readonly ElementTypes = ElementTypes;
  readonly IconPosition = IconPosition;
  readonly LoginStatus = LoginStatus;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  showButton$: Observable<boolean>;
  isMobile$: Observable<boolean>;
  icon$: Observable<SvgLibraryIcon>;

  profileName$: Observable<string>;
  loginStatus$: Observable<LoginStatus>;

  @Input()
  showName = false;

  @Input()
  nameStyle = 'font-body-1';

  @Input()
  trackingContext: string;

  ngOnInit(): void {
    this.profileName$ = this.store$.pipe(casProfileName());
    this.loginStatus$ = this.store$.pipe(loginStatus(), finShare());
    this.icon$ = this.store$.pipe(
      casProfileOrNot(),
      map((casProfile) => {
        if (!casProfile) {
          return SvgLibraryIcon.SINGLE_PAX;
        }
        if (casProfile.customerType === CasCustomerType.CORPORATE_USER) {
          return SvgLibraryIcon.B2B;
        }
        return SvgLibraryIcon.LOGGED_IN;
      })
    );
    this.isMobile$ = this.mediaQueryService.isBreakpoint$('mobile');
    this.showButton$ = this.nativeBridgeService.isInsideNativeWebView
      ? of(false)
      : this.loginStatus$.pipe(
          map((s) => SHOW_BUTTON_STATES.indexOf(s) !== -1),
          finShare()
        );
  }
}
